import { CustomerAddress } from "./customer-address";
import { Customer } from "./customer";
import { UnitType } from "./unit-type";

export class Paysheet {
    id:number = 0;
    customer_address_id:number = 0;
    customer_address:CustomerAddress = new CustomerAddress();
    customer_id:number = 0;
    customer:Customer = new Customer();
    ton_cost:number = 0;
    travel_cost:number = 0;
    ton_limit:number = 0;
    unit_type_id:number = 0;
    unit_type:UnitType = new UnitType();
    operator_percentage:number = 0;
    helper_percentage:number = 0;

    ton_cost_return:number = 0;
    travel_cost_return:number = 0;
    operator_percentage_return:number = 0;
    helper_percentage_return:number = 0;
    ton_cost_distribution:number = 0;
    travel_cost_distribution:number = 0;
}
